export interface CustomIcon {
    icon: string;
    style: string;
    color?: string;
    position?: IconPosition;
}

// eslint-disable-next-line no-shadow
export enum IconPosition {
    START,
    END
}
